import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "@/components/Reveal";
import InHomeGallery from "@/components/home/Gallery";
import { API } from "@/data/site";

export default function Journal() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/posts`).then((res) => setPosts(res.data)).catch(() => {});
  }, []);

  return (
    <main className="min-h-screen bg-ivory pt-32 pb-24 lg:pt-40" data-testid="journal-page">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <FadeUp>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-sienna">The journal</p>
          <h1 className="mt-5 max-w-3xl font-serif text-5xl font-light leading-tight text-espresso lg:text-6xl">
            Notes from the <span className="italic text-sienna">fourth trimester</span>
          </h1>
        </FadeUp>

        <div className="mt-16 space-y-0">
          {posts.map((p, i) => (
            <FadeUp key={p.id} delay={0.05 * i}>
              <Link
                to={`/journal/${p.slug}`}
                data-testid={`journal-post-${p.slug}`}
                className="group grid grid-cols-1 items-center gap-8 border-t border-espresso/15 py-12 lg:grid-cols-12"
              >
                <div className="overflow-hidden rounded-xl border border-espresso/15 lg:col-span-4">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="lg:col-span-7 lg:col-start-6">
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sienna">
                    {p.category} · {p.read_time}
                  </p>
                  <h2 className="mt-3 font-serif text-3xl font-medium leading-snug text-espresso lg:text-4xl">
                    {p.title}
                  </h2>
                  <p className="mt-4 max-w-xl text-base leading-relaxed text-cocoa">{p.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-espresso transition-colors group-hover:text-sienna">
                    Read on <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
                  </span>
                </div>
              </Link>
            </FadeUp>
          ))}
        </div>

        <InHomeGallery />
      </div>
    </main>
  );
}
